"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGlassZTAU = exports.getGlassZTA = exports.getGlassU = exports.getGlazingType = exports.GLASS_TYPE_NL = exports.GlassType = void 0;
exports.GlassType = {
    Single: 'single',
    Double: 'double',
    Triple: 'triple',
    HR: 'hr',
    HRp: 'hrPlus',
    HRpp: 'hrPlus2',
    Vacuum: 'vacuum',
};
exports.GLASS_TYPE_NL = {
    single: 'Enkel',
    double: 'Dubbel',
    triple: 'Triple',
    hr: 'HR',
    hrPlus: 'HR+',
    hrPlus2: 'HR++',
    hrPlus3: 'HR+++',
    vacuum: 'Vacuüm',
};
function getGlazingType(u, includePlusTypes = true) {
    if (!u)
        return undefined;
    if (includePlusTypes) {
        // NOTE: the assumed U-value for vacuum glass is also 1.2, but 'vacuum' glass is not selectable in the intake, so we can safely just return 'triple'.
        if (u <= 1.2)
            return 'triple';
        if (u <= 1.5)
            return 'hrPlus2';
        if (u <= 1.8)
            return 'hrPlus';
    }
    if (u <= 2.3)
        return 'hr';
    if (u <= 2.9)
        return 'double';
    return 'single';
}
exports.getGlazingType = getGlazingType;
const getGlassU = (type) => {
    const mapping = {
        [exports.GlassType.Single]: 5.2,
        [exports.GlassType.Double]: 2.9,
        [exports.GlassType.HR]: 2.3,
        [exports.GlassType.HRp]: 1.8,
        [exports.GlassType.HRpp]: 1.5,
        [exports.GlassType.Triple]: 1.2,
        [exports.GlassType.Vacuum]: 1.2,
    };
    return mapping[type];
};
exports.getGlassU = getGlassU;
const getGlassZTA = (type) => {
    const mapping = {
        [exports.GlassType.Single]: 0.8,
        [exports.GlassType.Double]: 0.7,
        [exports.GlassType.HR]: 0.6,
        [exports.GlassType.HRp]: 0.6,
        [exports.GlassType.HRpp]: 0.6,
        [exports.GlassType.Triple]: 0.5,
        [exports.GlassType.Vacuum]: 0.65,
    };
    return mapping[type];
};
exports.getGlassZTA = getGlassZTA;
const getGlassZTAU = (type) => {
    return { u: (0, exports.getGlassU)(type), zta: (0, exports.getGlassZTA)(type) };
};
exports.getGlassZTAU = getGlassZTAU;
